import LocomotiveScroll from "locomotive-scroll"
import "./navbar.css"

const NavBar = ()=> {
    const scrollTo_ = () => {
    
        const scroll = new LocomotiveScroll();
        
  
        let el = document.getElementById("projects")
      console.log(el)
      el?.scrollIntoView();
        
        // scroll.scrollTo( el, {
        //   'offset': 0,
        //   'callback': function() {
        //     // do something...
        //     console.log("sc")
        //   },
        //   'duration': 600,
        //   'easing': [0.25, 0.00, 0.35, 1.00],
        //   'disableLerp': true
        // } );
      }

    return (
     <div className="navbar" data-scroll-section>
        <div className="logo">
            <h1>sk</h1>

        </div>

        <div className="nav">
            <li onClick={()=>scrollTo_()}><a>Projects</a></li>

        </div>
     </div>
    )
}

export default NavBar 